// src/pages/Experience.jsx
import { experience } from '../models/portfolioData';

export default function Experience() {
  return (
    <section className="section bg-gray-50 dark:bg-[#0f0f17]" id="experience">
      <div className="container">
        <div className="text-center">
          <p className="section-subtitle">Where Have I Worked ?</p>
          <h6 className="section-title mb-6">Work Experience</h6>
        </div>

        {/* Timeline wrapper */}
        <div className="max-w-4xl mx-auto space-y-8">
          {experience.map((exp) => (
            <div
              key={exp.id}
              className="bg-white dark:bg-[#171722] border border-gray-200 dark:border-[#272738] rounded p-6 shadow-sm hover:shadow-md transition-shadow relative"
            >
              {/* Header: Company, Role & Duration badge */}
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 border-b border-gray-100 dark:border-[#242436] pb-4 mb-4">
                <div>
                  <h5 className="font-heading text-xl text-primary font-bold mb-1">
                    {exp.company}
                  </h5>
                  <div className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                    {exp.role}
                  </div>
                </div>

                <div className="flex items-center gap-2 flex-wrap">
                  <span className="bg-purple-50 dark:bg-[#232334] text-primary dark:text-[#a59cca] text-xs font-semibold px-3 py-1 rounded-full border border-purple-100 dark:border-[#2f2f45]">
                    {exp.period}
                  </span>
                  <span className="bg-gray-100 dark:bg-[#1f1f2e] text-gray-600 dark:text-gray-400 text-xs px-2.5 py-1 rounded border border-gray-200 dark:border-[#2b2b3d]">
                    {exp.type}
                  </span>
                </div>
              </div>

              {/* Career Progression if multiple roles exist */}
              {exp.careerProgression && exp.careerProgression.length > 0 && (
                <div className="mb-4 space-y-1.5 pl-3 border-l-2 border-primary/30">
                  {exp.careerProgression.map((prog, idx) => (
                    <div key={idx} className="flex justify-between text-xs text-gray-500 dark:text-gray-400">
                      <span className="font-medium text-gray-700 dark:text-gray-300">{prog.role}</span>
                      <span>{prog.period}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* Bullet Points */}
              <ul className="space-y-2 mb-5">
                {exp.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-2.5 text-sm text-gray-600 dark:text-gray-300">
                    <span className="text-primary font-bold mt-0.5">›</span>
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>

              {/* Tech Stack Chips */}
              <div className="flex flex-wrap gap-1.5 pt-2 border-t border-gray-100 dark:border-[#242436]">
                {exp.stack.map((s) => (
                  <span
                    key={s}
                    className="bg-gray-50 dark:bg-[#1f1f2e] text-gray-600 dark:text-gray-400 text-xs px-2.5 py-0.5 rounded border border-gray-200 dark:border-[#2a2a3c]"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
